exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".position-title {\n  margin-top: 0;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.target-group-item {\n  padding-top: 3px;\n  padding-left: 3px;\n}\n\n.target-group-item__button {\n  margin-top: 5px;\n  margin-right: 5px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/modules/target-groups/target-groups-list/target-groups-list.component.css
// module id = ../../../../../src/app/modules/target-groups/target-groups-list/target-groups-list.component.css
// module chunks = main